import { Injectable } from '@angular/core';
import { CanActivate, ActivatedRouteSnapshot, RouterStateSnapshot } from '@angular/router';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { AccountService } from 'src/app/shared/account.service';

@Injectable()
export class CanactivateviadropshippingadminService implements CanActivate {

 constructor(private accountService: AccountService) {}


    canActivate(route:ActivatedRouteSnapshot, state:RouterStateSnapshot):Observable<boolean>|boolean {
        return this.accountService.isDropShippingAdmin().pipe(map(auth => {
            if (auth) {
                return true;
            }

            return false;
        }))
    }

}
